import React from 'react';

import CustomerLogos from '@components/CustomerLogos';
import CustomersSection from '@components/CustomersSection';
import CustomHead from '@components/CustomHead';
import FiveCardGridSection from '@components/FiveCardGridSection';
import Footer from '@components/FooterNew';
import Header from '@components/HeaderNew';
import HeroBottom from '@components/HeroBottom';
import HeroSection from '@components/product/HeroSection';
import MainBenefitsSection from '@components/product/MainBenefitsSection';
import SubfeaturesSection from '@components/product/SubfeaturesSection';
import SupportedConnectionsSection from '@components/product/SupportedConnectionsSection';
import { ProductPageContext } from '@contexts/PageContext';
import { revalidate } from '@utils/constants';
import { getProductPages } from '@utils/contentfulClient';
import { parseContentfulData } from '@utils/contentfulFunctions';
import { ContentfulImage } from '@utils/propTypes';

export const getStaticProps = async () => {
  try {
    const pages = await getProductPages();
    const foundPage = pages.find(
      (page) => page.fields.slug === `/product/connections`,
    );

    return {
      props: {
        data: foundPage?.fields,
      },
      revalidate,
    };
  } catch (error) {
    console.error(error);
    return {
      props: {
        data: null,
        err: 'Something went wrong 😕',
      },
    };
  }
};

type parsedDataType = {
  ledeText?: string;
  logosSection?: {
    heading: string;
    logos: ContentfulImage[];
  };
  metaTags?: {
    description: string;
    image: ContentfulImage;
    title: string;
  };
};

const Product = ({ data }) => {
  const parsedData: parsedDataType = parseContentfulData(data);
  const { metaTags, logosSection } = parsedData;

  return (
    <>
      <CustomHead
        meta={{
          title: metaTags.title,
          description: metaTags.description,
          image: metaTags.image.file.url,
        }}
        openGraph={{
          title: metaTags.title,
          description: metaTags.description,
          image: metaTags.image.file.url,
        }}
      />
      <main>
        <ProductPageContext.Provider value={parsedData}>
          <Header />
          <HeroSection />
          <CustomerLogos
            spacing="pb-6 lg:pb-20 pt-10 lg:pt-20"
            heading={logosSection.heading}
            logos={logosSection.logos}
          />
          <MainBenefitsSection />
          <SubfeaturesSection />
          <SupportedConnectionsSection />
          <FiveCardGridSection
            title="Why PopSQL?"
            card_3={{
              title: 'Enterprise grade security',
              text: 'SOC 2 and GDPR compliance, SSO/SCIM integrations, versatile database connectivity, and precise access controls.',
              image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/images/enterprise_security.png`,
            }}
          />
          <CustomersSection
            col1_ids={[5, 6]}
            col2_ids={[2, 7]}
            col3_ids={[3, 9]}
          />
          <HeroBottom
            icon={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/popsql_app_icon.png`}
            title="The most powerful workspace for data teams"
            description=""
            spacing="mt-20 md:mt-52 mb-20 md:mb-40 px-4 gap-4"
          />
        </ProductPageContext.Provider>
      </main>
      <Footer />
    </>
  );
};

export default Product;
